import { render } from "./ProfaceWingIntro.vue?vue&type=template&id=f636b49e&scoped=true"
import script from "./ProfaceWingIntro.vue?vue&type=script&lang=js"
export * from "./ProfaceWingIntro.vue?vue&type=script&lang=js"

import "./ProfaceWingIntro.vue?vue&type=style&index=0&id=f636b49e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f636b49e"]])

export default __exports__